/**
 * Close footer market/language picker when clicking outside or pressing Escape.
 * Remember explicit market choices so geo suggestion does not override them.
 */
(function () {
  var pickerSelector = '.footer-zenbox__market-picker';
  var STORAGE_PREFERENCE = 'zenbox_market_preference';
  var STORAGE_STAY = 'zenbox_geo_stay';

  function closePickers() {
    document.querySelectorAll(pickerSelector + '[open]').forEach(function (picker) {
      picker.removeAttribute('open');
    });
  }

  function rememberMarketChoice(link) {
    if (!(link instanceof HTMLAnchorElement)) {
      return;
    }

    var href = link.getAttribute('href') || '';
    var match = href.match(/^\/((?:de|en|dk)-[a-z]{2})(?:\/|$)/);
    if (!match) {
      return;
    }

    sessionStorage.setItem(STORAGE_PREFERENCE, match[1]);
    sessionStorage.removeItem(STORAGE_STAY);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    var marketLink = target.closest('.footer-zenbox__market-lang-btn');
    if (marketLink) {
      rememberMarketChoice(marketLink);
      return;
    }

    if (target.closest(pickerSelector)) {
      return;
    }

    closePickers();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePickers();
    }
  });
})();
